import React from 'react';
import PropTypes from 'prop-types';

const ExternalLink = props => (
  <a target="_blank" rel="noopener" {...props}>
    {props.children}
  </a>
);

ExternalLink.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ExternalLink;



// WEBPACK FOOTER //
// ./src/components/ExternalLink.js